import React from "react";
import "./TermsConditions.css";

const TermsConditions = () => {
  return (
    <div className="terms-page">
      <div className="terms-hero">
        <div className="container">
          <span className="terms-badge">Terms & Conditions</span>
          <h1>Terms Governing Use Of Our Website</h1>
          <p>
            These Terms and Conditions explain the rules, responsibilities, and
            limitations that apply when you access our website, browse products,
            or place orders through our platform.
          </p>
        </div>
      </div>

      <div className="container terms-content">
        <div className="terms-card">
          <h2>Acceptance Of Terms</h2>
          <p>
            By accessing or using this website, you agree to be bound by these
            Terms and Conditions, our policies, and any other guidelines posted
            on the website.
          </p>
          <p>
            If you do not agree with these terms, you should not use the
            website.
          </p>
        </div>

        <div className="terms-card">
          <h2>Eligibility</h2>
          <p>
            You agree that any information you provide is accurate, current, and
            complete, and that you are legally capable of entering into binding
            transactions where required.
          </p>
        </div>

        <div className="terms-card">
          <h2>Products & Availability</h2>
          <p>
            All products listed on the website are subject to availability and
            may be updated, modified, or discontinued without prior notice.
          </p>
          <p>
            We make reasonable efforts to display product details accurately,
            but colors, sizing, packaging, or appearance may vary slightly due
            to screens, photography, or supplier changes.
          </p>
        </div>

        <div className="terms-card">
          <h2>Pricing & Payments</h2>
          <p>
            Prices displayed on the website are subject to change at any time
            without prior notice unless otherwise required by law.
          </p>
          <p>
            We reserve the right to cancel or refuse any order in case of
            pricing errors, suspected fraud, failed payment, or unavailable
            inventory.
          </p>
        </div>

        <div className="terms-card">
          <h2>Order Acceptance</h2>
          <p>
            Placing an order does not automatically guarantee acceptance. Orders
            may be reviewed, confirmed, rejected, or canceled based on payment
            status, stock availability, delivery serviceability, or verification
            requirements.
          </p>
        </div>

        <div className="terms-card">
          <h2>Shipping & Delivery</h2>
          <p>
            Shipping timelines are estimates only and may vary depending on your
            location, courier performance, weather conditions, holidays, or
            other operational factors.
          </p>
          <p>
            Please refer to our Shipping Policy page for full shipping-related
            details.
          </p>
        </div>

        <div className="terms-card">
          <h2>Returns, Refunds & Cancellations</h2>
          <p>
            Returns, refunds, exchanges, and cancellations are subject to our
            applicable return or refund policy, including product eligibility
            and time limits where relevant.
          </p>
        </div>

        <div className="terms-card">
          <h2>User Accounts</h2>
          <p>
            If you create an account, you are responsible for maintaining the
            confidentiality of your login details and for all activity under
            your account.
          </p>
          <p>
            We reserve the right to suspend or terminate accounts involved in
            misuse, fraud, abuse, or policy violations.
          </p>
        </div>

        <div className="terms-card">
          <h2>Prohibited Activities</h2>
          <p>
            You agree not to misuse the website, interfere with its operation,
            attempt unauthorized access, upload harmful code, scrape content, or
            engage in fraudulent or unlawful activity.
          </p>
        </div>

        <div className="terms-card">
          <h2>Intellectual Property</h2>
          <p>
            All website content including text, branding, logos, graphics,
            product content, layouts, and design elements is owned by or
            licensed to us unless otherwise stated.
          </p>
          <p>
            You may not reproduce, distribute, copy, or commercially exploit any
            content without prior written permission.
          </p>
        </div>

        <div className="terms-card">
          <h2>Limitation Of Liability</h2>
          <p>
            To the maximum extent permitted by law, we are not liable for any
            indirect, incidental, special, or consequential damages resulting
            from use of the website, delays, product unavailability, or service
            interruptions.
          </p>
        </div>

        <div className="terms-card">
          <h2>Third-Party Services</h2>
          <p>
            Our website may rely on or link to third-party services such as
            payment gateways, courier partners, analytics tools, or external
            links. Their services are governed by their own terms and policies.
          </p>
        </div>

        <div className="terms-card">
          <h2>Changes To Terms</h2>
          <p>
            We may revise these Terms and Conditions at any time by updating
            this page. Continued use of the website after changes are posted
            means you accept the updated terms.
          </p>
        </div>

        <div className="terms-card">
          <h2>Contact Information</h2>
          <p>
            For questions related to these Terms and Conditions, please contact
            us using the support or contact information provided on the website.
          </p>
        </div>
      </div>
    </div>
  );
};

export default TermsConditions;